module.exports = __webpack_public_path__ + "static/media/icon_schedule_phone_blue.c78b8607.svg";